import { render, staticRenderFns } from "./TestimonialCarousel.vue?vue&type=template&id=2c04418f&scoped=true"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js"
import style0 from "./TestimonialCarousel.vue?vue&type=style&index=0&id=2c04418f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04418f",
  null
  
)

export default component.exports